import { AccountInfo, EventType, RedirectRequest } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import React, { useEffect, useState } from 'react';
import ConfigService from './services/config.service';

const MsalWrapper = ({ children }: { children: React.ReactNode }) => {
    const { instance, accounts } = useMsal();
    const [authSuccess, setAuthSuccess] = useState(false);

    useEffect(() => {
        (async () => {
            if (!authSuccess) {
                // Set active account on page load
                if (accounts.length > 0) {
                    if (accounts[0].environment.includes('login.windows.net') && sessionStorage.getItem('isInternal') === 'true') {
                        instance.setActiveAccount(accounts[0]);
                    } else {
                        instance.logout();
                    }
                }

                await instance.initialize();

                instance.addEventCallback((event) => {
                    // Set active account after redirect
                    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload && (event.payload as any).account) {
                        const account = (event.payload as any).account as AccountInfo;
                        instance.setActiveAccount(account);
                    }
                });

                let loginRequest: RedirectRequest | undefined = undefined;
                if (sessionStorage.getItem('isInternal') === 'true') {
                    // Azure AD login
                    loginRequest = { scopes: ConfigService.azureADScope.scopes };
                } else {
                    // Azure B2C login
                    loginRequest = { scopes: ConfigService.azureB2CScope.scopes };
                }

                instance
                    .handleRedirectPromise()
                    .then(async (authResult) => {
                        // Check if user signed in
                        const account = instance.getActiveAccount();
                        if (!account) {
                            // Redirect anonymous user to login page
                            await instance.loginRedirect(loginRequest);
                        }

                        setAuthSuccess(true);
                    })
                    .catch((err) => console.error(err));
            }
        })();
    }, [authSuccess]);

    return <>{authSuccess ? children : <div>Trying to authenticate user...</div>}</>;
};

export default MsalWrapper;
